import { render, staticRenderFns } from "./trainplan.vue?vue&type=template&id=a77db32c&scoped=true"
import script from "./trainplan.vue?vue&type=script&lang=js"
export * from "./trainplan.vue?vue&type=script&lang=js"
import style0 from "./trainplan.vue?vue&type=style&index=0&id=a77db32c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a77db32c",
  null
  
)

export default component.exports